import { connect } from 'react-redux'
import * as treatmentQuotationAction from '../../state/quotation/action'
import * as selector from '../../state/quotation/selector'
import MedicalPhotoCheckWidget from './MedicalPhotoCheckWidget'
import * as customerSelector from '../../../customer/state/detail/selector'
import * as imageSelector from '../../../customer/state/image/selector'
import * as action from '../../../customer/state/image/action'
import { PRODUCT_TYPE_ALIGNERS } from '../../state/quotation/const'

const mapStateToProps = (state, props) => {
    return {
        treatmentQuotation: selector.selectTreatmentQuotation(state),
        customerId: customerSelector.selectCustomerId(state),
        customer: customerSelector.selectCustomer(state),
        imageVersionList: imageSelector.selectOrderedImageVersionList(state),
        selectedImageType: imageSelector.selectSelectedImageType(state),
        currentStep: imageSelector.selectCurrentStep(state),
        slideIndex: imageSelector.selectSlideIndex(state),
        productType: PRODUCT_TYPE_ALIGNERS,
    }
}

const mapDispatchToProps = {
    findImageVersion: action.findImageVersion,
    findOrCreateTreatmentQuotation: treatmentQuotationAction.findOrCreateTreatmentQuotation,
    rotateCustomerImage: action.rotateCustomerImage,
    setSelectedImageType: action.setSelectedImageType,
    setCurrentStep: action.setCurrentStep,
    setSlideIndex: action.setSlideIndex,
}

export default connect(mapStateToProps, mapDispatchToProps)(MedicalPhotoCheckWidget)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/MedicalPhotoCheckWidgetContainer.js